import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConfirmationService} from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent {

  @Output() cleanEvent = new EventEmitter<void>();

  @Input() disableSend: boolean;
  @Output() createEvent = new EventEmitter<void>();

  @Input() disableValidation: boolean;
  @Output() validateEvent = new EventEmitter<void>();

  @Input() message: string = "";

  constructor(
    private confirmationService: ConfirmationService) { }

  validar():void {
    this.validateEvent.emit();
  }


  crear():void {
    this.confirmationService.confirm({
      message: this.message,
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.createEvent.emit();
      },
      reject: () => {
      }
  });
  }

  limpiarData():void {
    this.cleanEvent.emit();
  }

}
